import type { Transition } from "@uirouter/core";

import Sentry from "@similarweb/sentry-logger";

import { chosenSites } from "app/common/services/chosenSites";
import type { ISimilarInfoItem } from "app/services/sitesService/types";
import { getUrlComponents } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";

const MAX_COMPETITORS = 2;

const normalizedSimilarSite = (item: ISimilarInfoItem | string) => {
    const site = typeof item === "string" ? item : item.Domain;
    const { subdomain } = getUrlComponents(site);
    return {
        url: site,
        searchType: subdomain ? "subdomain" : "domain",
    };
};

export const onRedirectUpdateInlineQueryBar = async (transition: Transition) => {
    const toParams = transition.params();

    if (!toParams.competitorsFilter && toParams.key) {
        let similarSites;
        try {
            await transition.injector().getAsync("siteInfo");

            similarSites = (chosenSites.similarSitesData().slice(0, MAX_COMPETITORS) as ISimilarInfoItem[]).map(
                normalizedSimilarSite,
            );
        } catch (error) {
            Sentry.error("Error fetching similar sites", error as Error);
            similarSites = [];
        }
        return { params: { ...toParams, competitorsFilter: JSON.stringify(similarSites) } };
    }
};
